import FieldBase from './FieldBase'

export default class extends FieldBase {
  constructor({
    type = 'date',
    format = 'yyyy-MM-dd HH:mm:ss',
    clearable = false,
    valueFormat,
    ...args
  }) {
    super(args)
    const child = this.getComponentWithVModel('el-date-picker')
    child.attrs = {
      ...child.attrs,
      type,
      format,
      clearable,
      valueFormat
    }
    this.children = [child]
  }
}
